<script setup lang="ts">
import LGForParentsHero from "~/components/for-parents/LGForParentsHero.vue";
import LGForParentsText from "~/components/for-parents/LGForParentsText.vue";

const { t } = useI18n()

const title = t('forParents.seo.title')
const description = t('forParents.seo.description')

useSeoMeta({
    title,
    description,
    robots: 'index,follow',
})
</script>

<template>
    <div>
        <LGForParentsHero/>
        <LGForParentsText/>
    </div>
</template>

<style scoped>

</style>
